import React, {Component} from 'react';

export class Spinner extends Component {
    renderSpinnerClass() {
        if(this.props.specialClass !== undefined) {
            return this.props.specialClass;
        }
        return "lds-dual-ring";
    }

    render() {
        return (
            <div className={this.renderSpinnerClass() + ' ' + this.props.color}/>
        )
    }
}
